// extracted by mini-css-extract-plugin
export default {"Bookmark":"SaveVideo_Bookmark__I9ymu","SavedItem":"SaveVideo_SavedItem__Gm9S0","Active":"SaveVideo_Active__-Xs7C","TooltipContainer":"SaveVideo_TooltipContainer__2dx5U"};